
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
import { RespuestaPredefinida } from '@/__env/lib/Preguntas/RespuestaPredefinida';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Pregunta: Pregunta;

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        async onAbierto()
        {
            if ( this.Abierto )
            {
                let e = await RespuestaPredefinida.find( {});
                this.Items = e.Items;
                this.Items[0].Respuesta
            }
        }

        public Items: RespuestaPredefinida[] = [];
        public Seleccionar( item: RespuestaPredefinida )
        {
            this.$emit( 'seleccionada', item );
            this.Abierto = false;
        }
    }
